import {NavigationGuardNext, Route} from 'vue-router/types/router'
import {useAuth} from '@/plugins/auth'
import {useIntendedRedirect} from '@/core/utils/intendedRedirect'

const authSignedGuard = (to: Route, from: Route, next: NavigationGuardNext): any => {
    const auth = useAuth()

    if (['login'].includes(<string>to.name) && auth.signed()) {
        const redirect = useIntendedRedirect().consume()
        next(redirect || {name: 'dashboard'})
    } else {
        next()
    }
}

export default authSignedGuard
